import { useState, useEffect, } from 'react';
import {
	Icon,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import withRedux from '../OneHat/data/hoc/withRedux';
import DivisionHeader from './DivisionHeader';
import useForceUpdate from '../OneHat/hooks/useForceUpdate';
import Loading from '../OneHat/components/Loading';
import useOneHatData from '../OneHat/data/useOneHatData';
import AccordionGridPanel from '../OneHat/components/AccordionGridPanel';
import _ from 'lodash';

function QuestionsAccordion(props) {
	const
		{
			currentQuestion,
			actions,
			navigation,
		} = props,
		forceUpdate = useForceUpdate(),
		[isReady, setIsReady] = useState(false),
		[divisions, Divisions] = useOneHatData('Divisions'),
		[questions, Questions] = useOneHatData('Questions'),
		onSelect = (question) => {
			actions.setQuestionById(question.questions__id);
			navigation.push('Question');
		};

	useEffect(() => {
		if (!Divisions || !Questions) {
			return;
		}
		
		if (Divisions.isDestroyed || Questions.isDestroyed) {
			return; // for auto-reload of Expo
		}
		
		setIsReady(true);

		Questions.ons(['load', 'change'], forceUpdate);
		return () => {
			Questions.offs(['load', 'change'], forceUpdate);
		};

	}, [Divisions, Questions]);

	if (!isReady) {
		return <Loading />;
	}

	// Build sections
	const sections = [];
	let found = [],
		activeSectionIndexes = [];
	_.each(divisions, (division, ix) => {
		found = [];
		let isActive = false;
		_.each(questions, (question) => {
			if (question.divisions__id === division.id) {
				found.push(question);
				if (currentQuestion && question.questions__id == currentQuestion.id) {
					isActive = true;
				}
			}
		});
		if (!_.isEmpty(found)) {
			const section = {
				title: division.divisions__name,
				data: found,
				schema: Questions.schema,
			};
			sections.push(section);
		}
		if (isActive) {
			activeSectionIndexes.push(ix);
		}
	});

	return <AccordionGridPanel
				containerStyle={{
					flex: 1,
					w: '100%',
					bg: 'primary.500',
				}}
				activeSectionIndexes={activeSectionIndexes}
				sections={sections}
				bottomToolbar={false}
				hideRightColumn={true}
				getRowProps={(question) => {
					const props = {
						bg: question.questions__is_gated ? 'trueGray.200' : '#fff',
						p: 2,
						borderBottomColor: 'primary.700',
					};
					if (currentQuestion && currentQuestion.id === question.id) {
						props.bg = '#ffa';
					}
					return props;
				}}
				columns={[
					(entity) => (key) => {
						return <Text
									key={key}
									flex={1}
									color={entity.questions__is_gated ? '#000' : 'primary.800'}
									pl={4}
								>{entity.questions__display_as}</Text>;
					},
					(entity) => (key) => {
						return <Icon
									key={key}
									as={FontAwesome5}
									name="angle-right"
									color="primary.800"
									variant="ghost"
									w={30}
									alignSelf="center"
									ml={3}
								/>;
					},
				]}
				renderSectionHeader={(section, ix, isActive) => {
					return <DivisionHeader isActive={isActive}>{section.title}</DivisionHeader>;
				}}
				onSelect={onSelect}
				noneFoundText="No questions found"
			/>;
}

export default withRedux(QuestionsAccordion, [
	'currentQuestion',
]);